import {ActionTypes} from "../actions/customers";
import {SHOW_SWITCH_USER_WINDOW, LOGOUT} from '../constants/actionTypes';
import {cloneDeep} from 'lodash';
import {GET_PROTECTED_AREAS_BY_USER_RESPONSE} from '../constants/actionTypes';
import {store} from './../main';
import {getProtectedAreasByUser} from "../actions/auth";

const initialState = {
  currentEntity: null, // the one we currently select in the List, list selection
  activeEntity: null, // the one set in the system
  data: null,
  willSetCurrentUser: false
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_SWITCH_USER_WINDOW: // when window is shown reset the flag
      return {...state, willSetCurrentUser: !action.payload};
    case ActionTypes.SELECT_ENABLED_ENTITY:
      return {...state, currentEntity: action.payload};
    case ActionTypes.APP_SET_AS_CUSTOMER:
      return handleSetAsCustomer(state, action);
    case GET_PROTECTED_AREAS_BY_USER_RESPONSE:
      return {...state, data: action.payload, currentEntity: null};
    case LOGOUT:
      document.kvConfig.asCustomer = 0;
      localStorage.removeItem('asCustomer');
      return {...state, currentEntity: null, activeEntity: null, willSetCurrentUser: true, data: null};
    default:
      return state;
  }
}


function handleSetAsCustomer(state, {payload}) {
  const {set} = payload;
  if (set) {
    document.kvConfig.asCustomer = state.currentEntity.id;
    localStorage.setItem('asCustomer', JSON.stringify(state.currentEntity));
    return {...state, activeEntity: cloneDeep(state.currentEntity), currentEntity: null, willSetCurrentUser: true};
  }

  document.kvConfig.asCustomer = 0;
  localStorage.removeItem('asCustomer');
  return {...state, activeEntity: null, currentEntity: null, willSetCurrentUser: true, data: null};
}

/**
 * Returns the user set by the super-admin
 */
export function asUserId(state) {
  return (state && state.activeEntity) ? state.activeEntity.id : null;
}


export function asFabricatorId(state) {
  return (state && state.activeEntity) ? state.activeEntity.customerBaseId : null;
}


/**
 * Retrieves the asUserId from localstorage if exists
 */
export  function asCustomerSaved() {
  const json = localStorage.getItem('asCustomer');
  if (!json)
    return null;
  return JSON.parse(json);
}

export function trySetAsCustomer(){
  const obj = asCustomerSaved();
  if (!obj)
    return false;
  console.log(obj);
  store.dispatch({type: ActionTypes.SELECT_ENABLED_ENTITY, payload: obj});
  store.dispatch({type: ActionTypes.APP_SET_AS_CUSTOMER, payload: {set: true}});
  store.dispatch(getProtectedAreasByUser(obj.id, obj.customerBaseId));
  return true;
}
